<template>
  <div v-if="!isMensurationForbidden && !isPreviousDateSession">
    <div v-if="isCurrentIntervalShow">
      <current-interval-form-menu
          v-on:save-session="onSaveSession"></current-interval-form-menu>
    </div>

    <div class="mdc-menu__backdrop" v-if="isOpenMDCMenu"
         @click.prevent="hideMdcMenu"></div>

    <mdc-menu-anchor class="fixed-menu">
      <mdc-button raised @click="isOpenMDCMenu=true">
        <i class="material-icons button-primary btn-fixed">more_horiz</i>
      </mdc-button>
      <mdc-menu v-model="isOpenMDCMenu">
        <mdc-menu-item v-if="!isPreviousDateSession">
          <mdc-button raised @click.prevent="onHelpModalBtnClick"
                      v-touch.preventDefault.longtap
                      @longtap="onHelpModalBtnClick">
            <i class="material-icons">format_align_left</i>{{'dashboard.writeRequest' | trans }}
          </mdc-button>
        </mdc-menu-item>
        <mdc-menu-item v-if="!isPreviousDateSession">
          <mdc-button raised @click.prevent="onBehaviorModalBtnClick"
                      v-touch.preventDefault.longtap
                      @longtap="onBehaviorModalBtnClick">
            <i class="material-icons">warning</i>{{'dashboard.writeUnwantedBehavior'
            | trans }}
          </mdc-button>
        </mdc-menu-item>

        <!--<mdc-menu-item>
          <mdc-button raised @click.prevent="onRequestModalBtnClick"
                      v-touch.preventDefault.longtap
                      @longtap="onRequestModalBtnClick">
            <div class="icon-wrapp"><img src="../../../assets/images/Union.svg"
                                         :alt="'dashboard.writeUnwantedBehavior' | trans"></div>{{'dashboard.requestHelp' | trans }}
          </mdc-button>
        </mdc-menu-item>-->
        <!--<mdc-menu-item>
          <mdc-button raised @click.prevent="onCommentModalBtnClick"
                      v-touch.preventDefault.longtap
                      @longtap="onCommentModalBtnClick">
            <i class="material-icons">chat_bubble</i>{{'dashboard.sendComment' |
            trans }}
          </mdc-button>
        </mdc-menu-item>-->

        <mdc-menu-item v-if="!hideDroModal && hasAccess && !isPreviousDateSession" :class="{'started' :isCurrentIntervalShow}">
          <mdc-button raised @click.prevent="onDROModalBtnClick"
                      v-touch.preventDefault.longtap
                      @longtap="onDROModalBtnClick">
            <span class="dro-icon"></span>{{'dro.dro_module' | trans }}
          </mdc-button>
        </mdc-menu-item>

        <mdc-menu-item v-for="dashboardProtocol in dashboardProtocolList" :key="dashboardProtocol.id">
          <mdc-button raised @click.prevent="dashboardProtocolClick(dashboardProtocol.id)"
                      :disabled="currentProtocolId == dashboardProtocol.id"
                      v-touch.preventDefault.longtap
                      @longtap="dashboardProtocolClick(dashboardProtocol.id)">
            <i class="material-icons">format_align_left</i>{{dashboardProtocol.shortcutMenuTitle}}
          </mdc-button>
        </mdc-menu-item>
      </mdc-menu>
    </mdc-menu-anchor>

    <div v-if="isRequestModalVisible">
      <request-help-modal :visible="isRequestModalVisible"
                          :clientId="modal.clientId"
                          v-on:close="onRequestModalClose">
      </request-help-modal>
    </div>

    <div v-if="isBehaviorModalVisible">
      <undesirable-behavior-modal :visible="isBehaviorModalVisible"
                                  :clientId="modal.clientId"
                                  :clientData="client"
                                  v-on:close="onBehaviorModalClose"
                                  v-on:cancel="onBehaviorModalCancel">
      </undesirable-behavior-modal>
    </div>

    <div v-if="isModalVisible">
      <write-appeals-modal :visible="isModalVisible"
                           :clientId="modal.clientId"
                           :clientData="client"
                           v-on:close="onModalClose"
                           v-on:cancel="onModalCancel">
      </write-appeals-modal>
    </div>

    <div v-if="isCommentModalVisible">
      <send-comment-modal :visible="isCommentModalVisible"
                          :clientId="modal.clientId"
                          v-on:close="onCommentModalClose">
      </send-comment-modal>
    </div>

    <div v-if="isModalReportVisible">
      <report-modal :visible="isModalReportVisible"
                    v-on:close="onReportModalClose">
      </report-modal>
    </div>

    <div v-if="isDroModalVisible">
      <dro-modal :visible="isDroModalVisible  && !hideDroModal"
                 :clientId="modal.clientId"
                 v-on:close="onDroModalClose">
      </dro-modal>
    </div>

    <div v-if="isProtocolModalVisible">
      <protocol-modal :visible="isProtocolModalVisible"
                 :protocolId="protocolId"
                 :clientData="client"
                 :clientId="modal.clientId"
                 v-on:close="onProtocolModalClose">
      </protocol-modal>
    </div>


  </div>

</template>

<script>
  import requestHelpModal from '../../dashboardModal/components/requestHelpModal';
  import undesirableBehaviorModal from '../../undesirableBehavior/components/AddModal.vue';
  import writeAppealsModal from '../../appeals/components/AddModal.vue';
  import sendCommentModal from '../../dashboardModal/components/sendCommentModal';
  import droModal from '../../dashboardModal/components/droModal';
  import Manager from '../../dro/api/Manager';
  import Auth from '../../../common/auth/Manager';
  import {mapActions, mapGetters, mapState} from 'vuex';
  import {showModal} from '../../../common/mixins/showModal';
  import CurrentIntervalFormMenu from '../../dro/components/CurrentIntervalFormMenu';
  import ReportModal from '../../dro/components/ReportModal';
  import protocolModal from '../../dashboardModal/components/protocolModal';
  import axios from 'axios';

  export default {
    name: 'DashboardMenu',
    props: {
      'clientData': {
        type: [Array, Object],
        default() {
          return null;
        },
      },
      'clientId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
      'hideDroModal': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'checkHasAccess': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'checkedHasAccess': {
        type: Boolean,
        default() {
          return false;
        },
      },
    },
    data() {
      return {
        isOpenMDCMenu: false,
        isModalVisible: false,
        isBehaviorModalVisible: false,
        isRequestModalVisible: false,
        isCommentModalVisible: false,
        isDroModalVisible: false,
        isModalReportVisible: false,
        isProtocolModalVisible: false,
        userClientId: null,
        isSettingsSet: false,
        hasAccess: true,
        modal: {
          data: {},
          clientId: '',
        },
        dashboardProtocolList: [],
        protocolId: null,
        currentProtocolId: null,
        apiClientUrl: '/users/clients/',
        client: null
      };
    },

    mixins: [showModal],

    components: {
      requestHelpModal,
      undesirableBehaviorModal,
      writeAppealsModal,
      sendCommentModal,
      droModal,
      CurrentIntervalFormMenu,
      ReportModal,
      protocolModal
    },

    computed: {
      ...mapState(['route']),
      ...mapState('dro/session', [
        'assignee',
        'isSessionStarted',
      ]),
      ...mapGetters('dro/session', [
        'shouldSessionBeSaved',
        'saveSessionData'
      ]),
      ...mapGetters('auth', [
        'isMensurationForbidden',
        'isPreviousDateSession'
      ]),
      isCurrentIntervalShow: function() {
        let id = this.clientId ? this.clientId : this.userClientId;

        let isIntervalEnable= (this.assignee.id == id) &&
            this.isSessionStarted && !this.hideDroModal;
        this.setIntervalEnable(isIntervalEnable);
        return isIntervalEnable
      },
      ...mapGetters('auth', [
        'isClient',
        'isTherapist',
      ]),

    },

    methods: {
      ...mapActions('dro/session', [
        'setIsSessionStarted',
        'setIntervalEnable'
      ]),

      getClient: async function(clientId) {
        try {
          let response = await axios.get(this.apiClientUrl + clientId);
          this.client = response.data.data;
          this.loaded = true;
        } catch (error) {
          console.info(error)
          this.loaded = true;
        }
      },

      async checkAccess() {
        let that = this;
        if(this.isClient){
          this.hasAccess = false;
        } else if(this.isTherapist){
          this.hasAccess = false;

          if (!this.checkedHasAccess){
            try {
              let id = this.clientId ? this.clientId : this.userClientId;
              let response = await Manager.hasAccess(id);
              if (response && response.data) {
                if (response.data.data.hasAccess) {
                  this.hasAccess = true;
                }
              }
            } catch (e) {
              console.error(e);
            }
          } else{
            this.hasAccess = this.checkHasAccess;
          }


        }
      },

      async getProtocolsList() {

        if(!this.isClient){
            try {
              let id = this.clientId ? this.clientId : this.userClientId;
              let response = await Manager.getDashboardProtocol(id);
              if (response && response.data) {
                this.dashboardProtocolList = response.data.data;
              }
            } catch (e) {
              console.error(e);
            }
        }
      },

      dashboardProtocolClick(id) {
        this.modal.clientId = this.clientId || this.route.params.clientId ||
            Auth.getUserInfo().id;
        this.isOpenMDCMenu = false;
        this.protocolId = id
        this.isProtocolModalVisible = true;
      },

      onHelpModalBtnClick() {
        this.modal.clientId = this.clientId || this.route.params.clientId ||
            Auth.getUserInfo().id;
        this.isModalVisible = true;
        this.isOpenMDCMenu = false;
      },
      onBehaviorModalBtnClick() {
        this.modal.clientId = this.clientId || this.route.params.clientId ||
            Auth.getUserInfo().id;
        this.isBehaviorModalVisible = true;
        this.isOpenMDCMenu = false;
      },
      onRequestModalBtnClick() {
        this.modal.clientId = this.clientId || this.route.params.clientId ||
            Auth.getUserInfo().id;
        this.isRequestModalVisible = true;
        this.isOpenMDCMenu = false;
      },
      onCommentModalBtnClick() {
        this.modal.clientId = this.clientId || this.route.params.clientId ||
            Auth.getUserInfo().id;
        this.isCommentModalVisible = true;
        this.isOpenMDCMenu = false;
      },

      onDROModalBtnClick() {
        this.isOpenMDCMenu = false;
        this.modal.clientId = this.clientId ? this.clientId : this.route.params.clientId
        if (this.isCurrentIntervalShow) {
          this.$router.push({name: 'dro-session', params: {
              clientId: this.modal.clientId
            }});
        } else{
          this.isDroModalVisible = true;
        }
        this.isOpen = false;
      },

      hideMdcMenu() {
        this.isOpenMDCMenu = false;
      },

      onBehaviorModalClose() {
        this.isBehaviorModalVisible = false;
      },
      onRequestModalClose() {
        this.isRequestModalVisible = false;
      },
      onCommentModalClose() {
        this.isCommentModalVisible = false;
      },
      onBehaviorModalCancel() {
        this.isBehaviorModalVisible = false;
      },
      onDroModalClose() {
        this.isDroModalVisible = false;
        this.isSettingsSet = true;
      },
      onProtocolModalClose() {
        this.isProtocolModalVisible = false;
      },
      onReportModalClose() {
        this.isModalReportVisible = false;
      },
      async onSaveSession() {
        this.processing = true;
        let id = this.clientId ? this.clientId : this.userClientId;
        let that = this;
        if (this.shouldSessionBeSaved) {
          if (!that.saveSessionData.assigneeId){
            that.saveSessionData.assigneeId = id
          }
          try {
            let {data: response} = await Manager.save(that.saveSessionData);
            if (!(response && response.data && response.data.id)) {
              throw new Error('Session wasn\'t saved');
            }
          } catch (e) {
            throw new Error('Unknown API error');
          }
        }
        this.isModalReportVisible = true;
        this.setIsSessionStarted(false);
        this.processing = false;
      },
    },
    async created() {
      this.userClientId = this.clientId || this.route.params.clientId ||
          Auth.getUserInfo().id;
      this.currentProtocolId = this.route.params.protocolId;
       this.checkAccess();
       this.getProtocolsList();

      if (!this.clientData){
        this.getClient(this.userClientId);
      } else {
        this.client = this.clientData
      }
    },

    beforeDestroy(){
      this.setIntervalEnable(false);
    },

    watch: {
      isOpenMDCMenu (newValue){
        if (newValue){
          this.getProtocolsList();
        }
      }
    }


  };

</script>



// WEBPACK FOOTER //
// src/modules/dashboardParent/components/DashboardMenu.vue